import React, { useContext } from "react";
import RoomContext from "../../../context/RoomContext";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import classnames from "classnames";
import { useIntl } from "react-intl";
import ListItem from "@material-ui/core/ListItem";
import AcceptIcon from "@material-ui/icons/CheckOutlined";
import Participant from "../Participant";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      alignItems: "center",
    },
  })
);

const LobbyPeerListItem = ({ id }) => {
  const classes = useStyles();
  const { roomClient } = useContext(RoomContext);
  const peer = useSelector((state) => state.lobbyPeers[id]);
  const canPromote = useSelector((state) =>
    state.me.roles.some((role) =>
      state.room.permissionsFromRoles.PROMOTE_PEER.includes(role)
    )
  );

  const intl = useIntl();

  const actions = [
    {
      label: intl.formatMessage({
        id: "tooltip.admitFromLobby",
        defaultMessage: "Click to let them in",
      }),
      disabled: !canPromote || peer.promotionInProgress,
      onClick: () => {
        roomClient.promoteLobbyPeer(peer.id);
      },
      children: <AcceptIcon />,
    },
    /*
    {
      label: intl.formatMessage({
        id: "tooltip.cancelFromLobby",
        defaultMessage: "Decline",
      }),
      disabled: !canPromote || peer.promotionInProgress,
      onClick: () => {
        //TODO cancel lobby
      },
      children: <CancelIcon />,
    },
    */
  ];
  const indicators = [];
  return (
    <ListItem
      className={classnames(classes.root)}
      key={peer.peerId}
      button
      alignItems="flex-start"
    >
      <Participant
        participant={peer}
        actions={actions}
        indicators={indicators}
      />
    </ListItem>
  );
};

export default LobbyPeerListItem;
